import styled, {css, system, SystemProps, th} from 'quickstart/system'
import {Shape} from 'quickstart/components/layout/Shape'

type CardProps = SystemProps & {$clickable?: boolean; $stretch?: boolean}

export const Card = styled.div<CardProps>(
  ({$clickable, $stretch}) => css`
    display: block; // for <Card as={UniversalLink} />
    overflow: hidden;
    background-size: cover;
    background-position: center;
    ${th('cards.default.card')};
    ${$clickable && {
      cursor: 'pointer',
    }};
    ${$stretch && {
      'flex-grow': '1',
      'justify-content': 'stretch',
    }};
    ${system};
  `,
)

export const Cover = styled(Shape)<SystemProps>`
  width: 100%;
  ${th('cards.default.cover')};
  ${system};
`

export const Body = styled.div<SystemProps>`
  word-break: break-word;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  ${th('cards.default.body')};
  ${system};
`

export const Footer = styled.div<SystemProps>`
  word-break: break-word;
  ${th('cards.default.footer')};
  ${system};
`
export const Meta = styled.div<SystemProps>`
  ${th('cards.default.meta')};
  ${system};
`

export const Heading = styled.div<SystemProps>`
  ${th('cards.default.heading')};
  ${system};
`

export const Description = styled.div<SystemProps>`
  ${th('cards.default.description')};
  ${system};
`

export const CallToAction = styled.div<SystemProps>`
  ${th('cards.default.callToAction')};
  ${system};
`
